import {PropsWithChildren} from "react";

import {Card} from "@/components/card/Card.tsx";
import {Divider} from "@/components/divider/Divider.tsx";

interface ScheduleEntryContainerProps extends PropsWithChildren {
  className?: string;
  title: string;
}

export const ScheduleEntryContainer = ({className, title, children}: ScheduleEntryContainerProps) => (
  <Card variant="white" className={className}>
    <div className="pulseTextBodyBold">{title}</div>
    <Divider className="my-3" />
    <div>{children}</div>
  </Card>
);
